import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PostalReturnList from './components/PostalReturnList';

const { Cell } = ResponsiveGrid;

const PostalRegistration = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="郵件包裹退貨"
        // description="行事曆列表"
        breadcrumbs={[
          {
            name: '郵件包裹',
          },
          {
            name: '郵件包裹退貨',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PostalReturnList />
    </Cell>
  </ResponsiveGrid>
);

export default PostalRegistration;
